export const products = [
  {
    img: "https://m.media-amazon.com/images/I/814J8FACIRL._AC_UL480_FMwebp_QL65_.jpg",
    name: 'SAMSUNG Galaxy Tab A7 Lite 8.7" 32GB WiFi Android Tablet w/ Long Lasting Battery, Compact, Slim Design, Sturdy Metal Frame, US',
    id: 1,
    price: 109,
    delivery: 48.67,
    country: "Pakistan",
    bestSeller: true,
  },
  {
    img: "https://m.media-amazon.com/images/I/81rAXAyovBL._AC_UL480_FMwebp_QL65_.jpg",
    name: 'Acer Chromebook Enterprise Spin 513 R841LT-S4JQ | 13.3" FHD IPS Touch Corning Gorilla Glass | Qualcomm Snapdragon 7c',
    id: 2,
    price: 664,
    delivery: 61.5,
    country: "Pakistan",
    bestSeller: false,
  },
  {
    img: "https://m.media-amazon.com/images/I/71GcsLmafcL._AC_UL480_FMwebp_QL65_.jpg",
    name: 'Lenovo - Tab P11 Plus - Tablet - 11" 2K Display - MediaTek Octa-Core Processor - 4GB Memory - 128GB Storage - Dolby Atmos -',
    id: 3,
    price: 339,
    delivery: 56.61,
    country: "Pakistan",
    bestSeller: true,
  },
  {
    img: "https://m.media-amazon.com/images/I/71RD3vsjIYL._AC_UL480_FMwebp_QL65_.jpg",
    name: "HP 15.6-inch Laptop, 11th Generation Intel Core i5-1135G7, Intel Iris Xe Graphics, 8 GB RAM, 256 GB SSD, Windows 11 Home",
    id: 4,
    price: 488,
    delivery: 64,
    bestSeller: true,
  },
  {
    img: "https://m.media-amazon.com/images/I/81uDDuBAwpL._AC_UL480_FMwebp_QL65_.jpg",
    name: "Lenovo - 2022 - IdeaPad Flex 5i - 2-in-1 Chromebook Laptop Computer - Intel Core i3-1115G4 - 13.3 FHD Touch Display - 8GB",
    id: 5,
    price: 327,
    delivery: 62.84,
    bestSeller: false,
  },
  {
    img: "https://m.media-amazon.com/images/I/61krikJxTmL._AC_UL480_FMwebp_QL65_.jpg",
    name: "Samsung Galaxy Tab A8 Android Tablet, 10.5” LCD Screen, 32GB Storage, Long-Lasting Battery, Kids Content, Smart Switch,",
    id: 6,
    price: 179,
    delivery: 48.98,
    bestSeller: true,
  },
  {
    img: "https://m.media-amazon.com/images/I/81HQMVKgf0L._AC_UL480_FMwebp_QL65_.jpg",
    name: "Acer Chromebook 512 Laptop | Intel Celeron N4020 | 12 HD+ Display | Intel UHD Graphics 600 | 4GB LPDDR4 | 32GB eMMC | Intel",
    id: 7,
    price: 115,
    delivery: 62,
    bestSeller: false,
  },
  {
    img: "https://m.media-amazon.com/images/I/81VZGpB+RrL._AC_UL480_FMwebp_QL65_.jpg",
    name: "HP 17 Laptop PC, 11 Generation Intel Core, 4 GB RAM, 256 GB SSD, UHD Graphics, 17.3 HD+ Display, Windows 11 Home, Wi-Fi &",
    id: 8,
    price: 385,
    delivery: 71,
    bestSeller: false,
  },
  {
    img: "https://m.media-amazon.com/images/I/71pvhTrmZDL._AC_UL480_FMwebp_QL65_.jpg",
    name: "Acer Aspire 5 A515-56-32DK Slim Laptop - 15.6 Full HD IPS Display - 11th Gen Intel i3-1115G4 Dual Core Processor - 4GB DDR4 -",
    id: 9,
    price: 289,
    delivery: 68.74,
    bestSeller: false,
  },
  {
    img: "https://m.media-amazon.com/images/I/71SCvh0L3OL._AC_UL480_FMwebp_QL65_.jpg",
    name: "Acer Aspire 5 A515-45-R74Z Slim Laptop | 15.6 Full HD IPS | AMD Ryzen 5 5500U Hexa-Core Mobile Processor | AMD Radeon Graphics ",
    price: 443,
    id: 10,
    bestSeller: true,

    delivery: 68.47,
  },
  {
    img: "https://m.media-amazon.com/images/I/81hR1tPG+ZL._AC_UL480_FMwebp_QL65_.jpg",
    price: 299,
    id: 11,
    delivery: 70,
    bestSeller: false,

    name: "HP Stream 11 Laptop, Intel Celeron N4020, 4 GB RAM, 64 GB Storage, 11.6” HD Anti-Glare Display, Windows 11, Long Batter",
  },
  {
    img: "https://m.media-amazon.com/images/I/71c5W9NxN5L._AC_UL480_FMwebp_QL65_.jpg",
    price: 199,
    id: 12,
    delivery: 61.8,
    bestSeller: false,
    name: "Acer Chromebook Spin 311 Convertible Laptop | Intel Celeron N4000 | 11.6 HD Touch Corning Gorilla Glass Display | 4GB",
  },
];
